<template>
    <div class="person">
        <div class="condition">
            <div class="item">
                <div class="label">医院名称:</div>
                <el-input v-model="conditionData.name" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">省市:</div>
                <el-cascader
                size="small"
                :options="options"
                v-model="conditionData.city"
                @change="handleRegionChange">
                </el-cascader>
            </div>
            <div class="item">
                <div class="label">等级:</div>
                <el-select v-model="conditionData.grade" size="small" placeholder="请选择"  class="citem-input" @change="changeCSvyType">
                    <el-option
                    v-for="item in gradeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                <el-button type="" size="small" @click="reset()">重置</el-button>
            </div>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                
                <el-table-column
                type="index"
                width="60"
                label="序号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="city"
                label="省市"
                width="120"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="name"
                label="医院名称"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="address"
                label="地址"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="grade"
                label="等级"
                width="120"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="major"
                label="特色专科"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop=""
                label="是否社保定点医院"
                align="center"


                >
                <template>
                    <span>是</span>
                </template>
                </el-table-column>
                <el-table-column
                prop=""
                label="是否公立"
                align="center"
                width="100"
                >
                <template>
                    <span>是</span>
                </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next, total"
                    :total="totalCount"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
                
            </div>
        </div>


        
       <!-- 大图预览 -->
        <el-image-viewer
            v-if="showBigImg"
            :on-close="closeViewer"
            :url-list="showBigImgList"
            :initial-index="imgIndex"
        />
    </div>
</template>
<script>
import api from '../../../api/main'
import { provinceAndCityData , CodeToText , TextToCode } from "element-china-area-data";
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
    name: 'person',
    components:{
        ElImageViewer,
    },
    watch: {
    },
    data () {
        return {
            uploadUrl:'',
            title:'',
            isShow:false,
            isAddDialog:false,
            isUpdateDialog:false,
            totalCount:66,
            conditionData:{
                petShop:'',
                page:1,
                pageSize:10,
            },
            addData:{},
            updateData:{
                petShop:'',
                contacts:'',
                phone:'',
                address:'',
                province:'',
                city:'',
                area:'',
                addressCode:'',
                projectPrices:[{
                    name: '',
                    price: '',
                }],
            },
            tableData:[],
            tableData1:[
                {city:'广东省-广州市',name:'中山大学附属第一医院',address:'广州市中山二路58号',grade:'三甲',major:'肾脏内科、消化内科、胃肠胰外科、血管甲状腺乳腺外科、肝胆外科、微创外科、骨外科、显微手外科、泌尿外科、器官移植中心、神经内科、生殖医学中心'},
                {city:'广东省-广州市',name:'中山大学附属医院附属第二医院(原：孙逸仙纪念医院)',address:'广州市沿江西路107号',grade:'三甲',major:'妇科、骨科、消化内科、内分泌科、心血管内科、普外科、小儿血液科、口腔颌面科、皮肤科等'},
                {city:'广东省-广州市',name:'中山大学附属第三医院',address:'天河区天河路600号',grade:'三甲',major:'传染病科、皮肤性病科、精神心理科、风湿病科、骨髓移植、骨科、胸心外科、介入放射科、康复科、耳鼻喉科等'},
                {city:'广东省-广州市',name:'中山大学肿瘤医院',address:'广州市东风东路651号',grade:'三甲',major:'肝胆科、鼻咽癌科、头颈肿瘤科、胸科、妇科、内科、放射治疗科、中医科'},
                {city:'广东省-广州市',name:'广州中医药大学附属骨伤科医院',address:'广州市江南大道中江南西路',grade:'',major:'脊柱病、骨关节病、骨肿瘤'},
                {city:'广东省-广州市',name:'广州中医药大学第一附属医院',address:'广州白云区机场路16号',grade:'三甲',major:'内科、外科、骨伤科、妇科、儿科、针灸科、肿瘤科、推拿科、口腔科、皮肤科、性病治疗中心、泌尿男科、肛肠科、眼科、耳鼻喉科、预防保健科、美容科、类风湿关节炎、系统性红斑狼疮、股骨头坏死、癫痫病、哮喘、糖尿病、肾病、老年性痴呆等'},
                {city:'广东省-广州市',name:'广东省第二中医院',address:'广州市恒福路60号',grade:'',major:'骨伤科、推拿科、针灸科、中风、乙肝、类风湿、高脂血症等'},
                {city:'广东省-广州市',name:'广东省口腔医院',address:'广州市江南大道南366号',grade:'',major:'口腔颌面外科、口腔正畸科、口腔种植科、口腔病理科、义齿制作中心、口腔修复、牙周病、粘膜病、美容牙科、牙体牙髓病等'},
                {city:'广东省-广州市',name:'广州越秀区西湖医院',address:'越秀区西湖路47号',grade:'',major:''},
                {city:'广东省-广州市',name:'广州市越秀区中医杂病医院',address:'广州市天成路晏公街10号',grade:'',major:''},
            ],
            tableData2:[  
                {city:'广东省-广州市',name:'广州市黄埔区中医院',address:'黄埔区蟹山路3号',grade:'',major:''},
                {city:'广东省-惠州市',name:'惠州市中心人民医院',address:'惠州市鹅岭北路41号',grade:'三甲',major:'神经内科、创伤骨科、人工股骨头置换术、全髋关节置换术、脊柱侧弯驼背矫形术、椎体前路减压脊柱重建术等'},
                {city:'广东省-惠州市',name:'惠州市人民医院',address:'惠州市惠城区桥东学北街1号',grade:'二甲',major:'骨科、口腔科、眼科、泌尿科、脑血管疾病'},
                {city:'广东省-惠州市',name:'惠州市第二人民医院',address:'惠州市惠城区下角菱湖二路',grade:'二甲',major:'肝胆胰外科、器官移植科、骨外科、神经外科、心胸外科、内科、传染科、妇产科、儿科、眼科、耳鼻咽喉科、口腔科、皮肤性病科、急诊医学科、康复医学科、预防保健科、医学检验科、医学影像科、核医学科、中医科、病理科、普外科等'},
                {city:'广东省-汕头市',name:'汕头大学医学院第一附属医院',address:'汕头市长平路57号',grade:'三甲',major:'心血管内科、风湿病、生殖中心、新生儿中心、神经外科中心'},
                {city:'广东省-汕头市',name:'汕头市中心医院',address:'汕头市外马路114号',grade:'二甲',major:'心外科、心内科、眼科、骨科、心血管外科等'},
                {city:'广东省-汕头市',name:'汕头大学医学院第二附属医院',address:'汕头市东厦路北段',grade:'三级',major:'精神科神经科、心理咨询、戒毒门诊'},
                
                {city:'广东省-澄海市',name:'澄海市人民医院',address:'澄海市环城北路',grade:'二甲',major:'中西医结合科、耳鼻喉科、传染病科等'},
                {city:'广东省-澄海市',name:'澄海市中医院',address:'澄城镇中山路4号',grade:'',major:''},
                {city:'广东省-澄海市',name:'澄海市妇幼保健院',address:'澄城镇中山路12号',grade:'',major:''},

                
            ],
            tableData3:[  
                {city:'广东省-深圳市',name:'中山大学深圳医疗中心',address:'深圳市罗湖区人民南路',grade:'',major:''},
                {city:'广东省-深圳市',name:'北京大学深圳医院(原深圳市中心医院)',address:'深圳莲花北路1120号',grade:'三甲',major:'生殖医学中心、腔镜外科、外科系统、内科'},
                {city:'广东省-深圳市',name:'深圳市人民医院暨南大学医学院附二院',address:'深圳市东门北路1017号',grade:'三甲',major:'心血管内科、老年医学科、创伤骨科、妇产科、胃肠外科等'},
                {city:'广东省-深圳市',name:'深圳市红十字会医院深圳市第二人民医院',address:'深圳市笋岗西路',grade:'三甲',major:'血液病、创伤外科、神经外科'},
                {city:'广东省-深圳市',name:'广州中医药大学深圳附属医院深圳市中医院',address:'深圳市福田区福华路1号',grade:'三甲',major:'中医消化内科、骨伤科、肝病科、急诊科、肾病科、痔瘘科、泪道病、蛇伤、男科等'},
                {city:'广东省-深圳市',name:'深圳市宝安区人民医院',address:'深圳市宝安区龙井二路118号',grade:'三甲',major:'骨科、急诊科、妇产科等'},
                {city:'广东省-深圳市',name:'深圳市宝安区中医院',address:'深圳市宝安区宝城30区裕安路',grade:'二甲',major:'骨伤科、妇科、肝炎、结石病等'},
                {city:'广东省-珠海市',name:'珠海市人民医院暨南大学医学院第三附属医院',address:'珠海市康宁路79号',grade:'三甲',major:'心血管内科、妇科肿瘤、骨科、呼吸内科、血液内科、消化内科、泌尿内科、神经内等'},
                {city:'广东省-珠海市',name:'广州中医药大学第二附属医院珠海医院',address:'珠海市景乐路53号',grade:'三甲',major:'心血管内科、呼吸内科、血液内科、消化内科、泌尿内科、内分泌内科、神经内科、脊柱科等'},
                {city:'广东省-珠海市',name:'珠海市妇幼保健院',address:'澄城镇中山路12号',grade:'三甲',major:'小儿外科、妇产科、骨科、针灸科等'},
            ],
            tableData4:[  
                {city:'广东省-佛山市',name:'佛山市第一人民医院',address:'佛山市文沙路91号',grade:'三甲',major:'颅脑外科、心血管内科、胸心血管外科、中医科、妇产科、角膜移植、全喉切除、脊椎脊髓外科中心等'},
                {city:'广东省-佛山市',name:'佛山市第二人民医院',address:'佛山市卫国路78号',grade:'三乙',major:'肝胆外科、呼吸内科、脑外科、眼科、心血管科等'},
                {city:'广东省-佛山市',name:'佛山市第三人民医院',address:'佛山市石湾区澜石镇',grade:'二甲',major:'普外科、脑外科、神经内科、老年科等'},
                {city:'广东省-佛山市',name:'佛山市第四人民医院佛山市肿瘤医院',address:'佛山市石湾区西樵镇',grade:'',major:''},
                {city:'广东省-佛山市',name:'佛山市第五人民医院',address:'南海市西樵山旅游渡假区',grade:'二甲',major:'创伤外科、妇科、心脑内科等'},

                {city:'广东省-佛山市',name:'佛山市中医院',address:'佛山市亲仁路6号',grade:'三甲',major:'骨伤科、肛肠科、心血管内科、手显外科等'},
                {city:'广东省-佛山市',name:'佛山市妇幼保健院',address:'佛山市福贤路75号',grade:'二甲',major:'妇产科、儿科'},
                {city:'广东省-佛山市',name:'佛山市口腔医院',address:'佛山市城区河滨路5号',grade:'二甲',major:'口腔科'},
                {city:'广东省-佛山市',name:'佛山市慢性病防治院',address:'佛山市城区丝织路20号',grade:'',major:'心脑血管疾病、呼吸系统、恶性肿瘤等'},
                {city:'广东省-南海市',name:'南海市中医院',address:'南海市桂城南五路16号',grade:'二甲',major:'泌尿内科、消化内科、心血管内科、妇产科、神经内科、呼吸内科、烧伤科、普外科等'},
               
                
                
            ],
            tableData5:[  
                {city:'广东省-南海市',name:'南海市妇幼保健院',address:'南海市桂城区桂平路',grade:'',major:'妇儿科、耳鼻喉科等'},
                {city:'广东省-南海市',name:'南海市平洲医院',address:'南海市平洲区太平路18号',grade:'一甲',major:'心血管内科、神经内科、泌尿外科、妇产科、眼科、牙科等'},
                {city:'广东省-南海市',name:'南海市盐步医院',address:'南海市盐步镇',grade:'',major:'骨科、普外科、消化内科、肾内科等'},

                {city:'广东省-肇庆市',name:'肇庆市第一人民医院',address:'肇庆市城中路174号',grade:'三甲',major:'妇科、肝胆外科、新生儿科、眼科、心血管内科、神经内科、呼吸内科、消化内科、心胸外科、神经外科、泌尿外科、烧伤整形外科等'},
                {city:'广东省-肇庆市',name:'肇庆市第二人民医院',address:'肇庆市建设二路2号',grade:'二甲',major:'肿瘤科、妇产科、五官科等'},
                {city:'广东省-肇庆市',name:'肇庆市第三人民医院',address:'肇庆市端州二路1号',grade:'二乙',major:'妇产科、烧伤整容科、中医科等'},
                {city:'广东省-肇庆市',name:'肇庆市中医院',address:'肇庆市端州六路20号',grade:'二甲',major:'肛肠科、骨伤科、脾胃、脑血管科等'},


                
                {city:'北京市',name:'北京中医药大学东直门医院',address:'东城区海运仓5号',grade:'三甲',major:'急症中心、中医脑病、肾病、中医内科、神经内科、内分泌科、呼吸科、血液肿瘤科、中医外科'},
                {city:'北京市',name:'北京市东四妇产医院东城区妇幼保健院',address:'东城区交道口南大街136号',grade:'',major:'妇产科等'},
                {city:'北京市',name:'北京市东单儿童医院',address:'东城区东华门柏树胡同23号',grade:'',major:''},
            ],
            tableData6:[  
                {city:'北京市',name:'北京市第六医院',address:'交道口北二条36号',grade:'二甲',major:'心血管内科、呼吸科、急诊科、妇产科、骨科等'},
                {city:'北京市',name:'北京公安医院',address:'东城区银闸胡同25号',grade:'三级',major:'心血管内科、肾脏内科、消化内科、呼吸内科、内分泌科、普外科、淋巴显微外科、泌尿外科、骨科、神经外科等'},
                {city:'北京市',name:'交通部北京交通医院',address:'安定门内大街车辇店胡同15号',grade:'二级',major:'心脏内科、普外科、口腔、妇科、消化内科、眼科、心血管内科、前列腺病等'},
                {city:'北京市',name:'北京市和平里医院',address:'东城区和平里北街18号',grade:'二甲',major:'糖尿病、乳腺疾病、口腔科、脑血管疾病等'},
                {city:'北京市',name:'东城区建国门医院',address:'东城区建国门后赵家楼胡同9号',grade:'一甲',major:'老年性疾等'},
                {city:'北京市',name:'东城区东华门医院',address:'东城区王府井大院17号',grade:'',major:'口腔科、皮肤科等'},
                {city:'北京市',name:'东城区安定门医院',address:'东城区安定门永恒胡同甲6号',grade:'一甲',major:''},
                {city:'北京市',name:'东城区朝阳门医院',address:'东城区东四南大街灯草胡同31号',grade:'一甲',major:'义眼科、临终关怀等'},
                {city:'北京市',name:'东城区东直门外医院',address:'东城区东外察慈小区7号楼',grade:'一甲',major:'糖尿病科、性生殖科等'},
                {city:'北京市',name:'东城区北新桥医院',address:'东城区东直门内大街184号',grade:'一甲',major:'乳腺门诊、骨（伤）科等'},
                {city:'北京市',name:'东城区长安医院',address:'东城区建国门老钱局胡同甲14号',grade:'一甲',major:''},
            ],
            tableData7:[  
                {city:'北京市',name:'中国医学科学院北京市协和医院',address:'东城区帅府园1号',grade:'三甲',major:''},
                {city:'北京市',name:'卫生部北京医院',address:'北京市东单大华路1号',grade:'三甲',major:'心脏内科、呼吸内科、神经内科、心胸外科、神经外科、骨科、老年病'},
                {city:'北京市',name:'北京中医院',address:'东城区美术馆后街23号',grade:'三甲',major:'针灸推拿、中医内科、肿瘤科、心血管科、消化科、肛肠科、肝病科、妇科、皮肤性病科、肾病科、骨科、外科'},
                {city:'北京市',name:'北京市妇幼保健院(原：北京妇产医院)',address:'东城区北池子骑河楼17号',grade:'三甲',major:'妇科、产科、新生儿科、计划生育科、男科'},
                {city:'北京市',name:'北京地坛医院(原：北京市第一传染病医院)',address:'安外大街地坛公园13号',grade:'三甲',major:'肝病、艾滋病'},
                {city:'北京市',name:'东城区长安医院',address:'东城区建国门老钱局胡同甲14号',grade:'一甲',major:''},
            ],

            addressList:[],
            options:provinceAndCityData,
            picList1:[],
            picList2:[],
            picList3:[],
            showBigImg:false,
            showBigImgList:[],
            imgIndex:0,

            list:[
                '化学药','生物制品','中成药','中药饮片'
            ],
            gradeList:[
                {label:'三甲',value:3},
                {label:'二甲',value:2},
                {label:'一甲',value:1},
            ]
        }
    },
    created(){
        

    },
    mounted(){
        this.tableData = this.tableData1
        // this.loadingData();
    },
    methods:{
        handleRegionChange(){
            
           
        },
        async addImg1(file){
            let res = await api.uploadOther(file.file);
            this.picList1.push(res);
        },
        async addImg2(file){
            let res = await api.uploadOther(file.file);
            this.picList2.push(res);
        },
        async addImg3(file){
            let res = await api.uploadOther(file.file);
            this.picList3.push(res);

        },
        // 图片查看
        closeViewer(){
            this.showBigImg = false;
        },
        previewImg(index,piclist){
            this.imgIndex = index
            this.showBigImgList = piclist;
            this.showBigImg = true;
        },
        clearImg(index,type){
            if(type==1){
                this.picList1.splice(index,1)
            }else if(type==2){
                this.picList2.splice(index,1)
            }else if(type==3){
                this.picList3.splice(index,1)
            }
        },
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            let res  = await api.collectPetQueryPager(this.conditionData);
            console.log(res);
            this.tableData = res.data.data.data;
            this.totalCount = res.data.data.totalCount;
        },
        selectData(){
            this.conditionData.page = 1;
            this.tableData = this.tableData1
            // this.loadingData();
        },
        reset(){
            this.conditionData = {
                // name:'',
                page:1,
                pageSize:10,
            };
            this.tableData = this.tableData1

            // this.loadingData();
        },
        handleCurrentChange(page){
            this.conditionData.page = page;
            if(page == 1){
                this.tableData = this.tableData1
            }
            if(page == 2){
                this.tableData = this.tableData2
            }
            if(page == 3){
                this.tableData = this.tableData3
            }
            if(page == 4){
                this.tableData = this.tableData4
            }
            if(page == 5){
                this.tableData = this.tableData5
            }
            if(page == 6){
                this.tableData = this.tableData6
            }
            if(page == 7){
                this.tableData = this.tableData7
            }
            // this.loadingData();
        },
        showAddDialog(){
            this.title = '新增';
            this.isShow = true;
            this.isAddDialog = true;
        },
       
        async addRole(){
            let res  = await api.CreateRole(this.addData);
            console.log(res);
            if(res.data.code == '200') {
                this.$message({
                    message: '添加成功',
                    type: 'success'
                });
                this.loadingData();
                this.addData = {};
                this.isAddDialog = false;
            }

        },
        async deletePetShop(row){

            this.$confirm('将删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deletePetShopFun(row.id);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });


            
        },
        async deletePetShopFun(id){
            let res  = await api.collectPetDelete(id);
            console.log(res);
            if(res.data.code == '200') {
                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
                this.loadingData();
                this.isAddDialog = false;
            }
        },
        async updateshop(){
            for(let index in this.updateData.projectPrices){
                this.updateData.projectPrices[index].price = parseFloat(this.updateData.projectPrices[index].price?this.updateData.projectPrices[index].price:0)
            }
            this.updateData.shopLog = JSON.stringify(this.picList1);
            this.updateData.jyzz = JSON.stringify(this.picList2);
            this.updateData.jyxm = JSON.stringify(this.picList3);
            let res  = await api.collectPetUpdate(this.updateData);
            console.log(res);
            if(res.data.code == '200') {
                this.$message({
                    message: '编辑成功',
                    type: 'success'
                });
                this.loadingData();
                this.isUpdateDialog = false;
            }

        },
        isUpdateDialogShow(row){
            this.title = '编辑';
            this.isShow = true;
            this.isUpdateDialog = true;
            this.updateData = row;
            this.addressList = this.updateData.addressCode.split(',');
            this.picList1 = JSON.parse(this.updateData.shopLog?this.updateData.shopLog:'[]')
            this.picList2 = JSON.parse(this.updateData.jyzz?this.updateData.jyzz:'[]')
            this.picList3 = JSON.parse(this.updateData.jyxm?this.updateData.jyxm:'[]')
        },
        deleteXM(index){
            this.updateData.projectPrices.splice(index);
        },
        handleAddRegionChange(codeArray){
            if(codeArray[0]){
                this.updateData.province = CodeToText[codeArray[0]]
                this.updateData.addressCode = codeArray[0]
            }
            if(codeArray[1]){
                this.updateData.city = CodeToText[codeArray[1]]
                this.updateData.addressCode = this.updateData.addressCode + ',' + codeArray[1]
            }
            if(codeArray[2]){
                this.updateData.area = CodeToText[codeArray[2]]
                this.updateData.addressCode = this.updateData.addressCode + ',' + codeArray[2]
            }
        },
        async downloadExcel(){
            let res = await api.exportInventory({
                "type": 11,
                "Condition":{
                    "petShop":this.conditionData.petShop,
                    "pageSize":10000,
                }
                
            },'宠物店资料收集');
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            .label{
                min-width: 80px;
                margin-left: 15px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }

    .dialog{
        padding-top: 20px;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        .item{
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            .label{
                width: 150px;
                margin-bottom: 5px;
            }
            .value{
                width: 215px;
            }
            .label-pic{
                width: 600px;
                display: flex;
                align-items: center;
                span{
                    color: red;
                    font-size: 20px;
                    margin: 0 4px;
                    margin-top: 2px;
                }
            }
            .pics{
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                margin-top: 10px;
                .pics-item{
                    width: 120px;
                    height: 120px;
                    position: relative;
                    margin-right: 10px;
                    margin-left: 10px;
                    .pics-item-img{
                        width: 120px;
                        height: 120px;
                    }
                    .close{
                        position: absolute;
                        top: -12px;
                        right: -12px;
                        width: 24px;
                        height: 24px;
                    }
                }
                .chooseimg{
                    margin-right: 10px;
                    margin-left: 10px;
                }
                img{
                    width: 120px;
                    height: 120px;
                    margin: 0;
                    margin-bottom: 20px;
                }
            }
        }
        
        .dialog-footer{
            width: 100%;
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            .el-button{
                margin-left: 20px;
            }
        }
    }
</style>
